export default "__VITE_ASSET__ypf7Zt3a__"